import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=5510015c&scoped=true&"
import script from "./SuccessDialog.vue?vue&type=script&lang=ts&"
export * from "./SuccessDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=5510015c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510015c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
